import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import create from "zustand/vanilla";
import { NetworkStatus } from "../../networkStatus";
import { deduplicateItems, sortItems } from "./utils";

function processItems(items) {
  var deduped = deduplicateItems(items);
  var sorted = sortItems(deduped);
  return sorted;
}

var defaultSetResultOptions = {
  shouldSetPage: true,
  shouldAppend: false
};
var initialStoreState = {
  items: [],
  metadata: {
    total_count: 0,
    unread_count: 0,
    unseen_count: 0
  },
  pageInfo: {
    before: null,
    after: null,
    page_size: 50
  }
};
export default function createStore() {
  return create(set => _objectSpread(_objectSpread({}, initialStoreState), {}, {
    // The network status indicates what's happening with the request
    networkStatus: NetworkStatus.ready,
    loading: false,
    // TODO: remove this function from the store as we're now using the
    // `setNetworkStatus` function to derive this information instead
    setLoading: loading => set(() => ({
      loading
    })),
    setNetworkStatus: networkStatus => set(() => ({
      networkStatus,
      loading: networkStatus === NetworkStatus.loading
    })),
    setResult: function setResult(_ref) {
      var {
        entries,
        meta,
        page_info
      } = _ref;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSetResultOptions;
      return set(state => {
        // We resort the list on set, so concating everything is fine (if a bit suboptimal)
        var items = options.shouldAppend ? processItems(state.items.concat(entries)) : entries;
        return {
          items,
          metadata: meta,
          pageInfo: options.shouldSetPage ? page_info : state.pageInfo,
          loading: false,
          networkStatus: NetworkStatus.ready
        };
      });
    },
    setMetadata: metadata => set(() => ({
      metadata
    })),
    resetStore: function resetStore() {
      var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStoreState.metadata;
      return set(() => _objectSpread(_objectSpread({}, initialStoreState), {}, {
        metadata
      }));
    },
    setItemAttrs: (itemIds, attrs) => {
      // Create a map for the items to the updates to be made
      var itemUpdatesMap = itemIds.reduce((acc, itemId) => _objectSpread(_objectSpread({}, acc), {}, {
        [itemId]: attrs
      }), {});
      return set(state => {
        var items = state.items.map(item => {
          if (itemUpdatesMap[item.id]) {
            return _objectSpread(_objectSpread({}, item), itemUpdatesMap[item.id]);
          }

          return item;
        });
        return {
          items
        };
      });
    }
  }));
}
//# sourceMappingURL=store.js.map